import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "item", "addBtn"]

  addItem() {
    const container = this.containerTarget
    const items = container.querySelectorAll("[data-landing-section-repeater-target='item']")
    const newIndex = items.length

    // Clone the first item and update indices
    const firstItem = items[0]
    if (!firstItem) return

    const clone = firstItem.cloneNode(true)

    // Clear all input/textarea values and update indices
    clone.querySelectorAll("input, textarea, select").forEach(input => {
      if (input.type === "checkbox") {
        input.checked = false
      } else if (input.type !== "hidden") {
        input.value = ""
      }
      // Update name index
      if (input.name) {
        input.name = input.name.replace(/\[\d+\]/, `[${newIndex}]`)
      }
      // Update id
      if (input.id) {
        input.id = input.id.replace(/_\d+$/, `_${newIndex}`)
      }
    })

    // Update label for attributes
    clone.querySelectorAll("label[for]").forEach(label => {
      label.htmlFor = label.htmlFor.replace(/_\d+$/, `_${newIndex}`)
    })

    container.appendChild(clone)
  }

  removeItem(event) {
    const item = event.target.closest("[data-landing-section-repeater-target='item']")
    const container = this.containerTarget
    const items = container.querySelectorAll("[data-landing-section-repeater-target='item']")

    if (items.length <= 1) {
      // Don't remove the last item, just clear it
      item.querySelectorAll("input, textarea").forEach(input => {
        if (input.type !== "checkbox" && input.type !== "hidden") input.value = ""
        else if (input.type === "checkbox") input.checked = false
      })
      return
    }

    item.remove()
    this.reindexItems()
  }

  reindexItems() {
    const container = this.containerTarget
    const items = container.querySelectorAll("[data-landing-section-repeater-target='item']")
    items.forEach((item, index) => {
      item.querySelectorAll("input, textarea, select").forEach(input => {
        if (input.name) {
          input.name = input.name.replace(/\[\d+\]/, `[${index}]`)
        }
        if (input.id) {
          input.id = input.id.replace(/_\d+$/, `_${index}`)
        }
      })
      item.querySelectorAll("label[for]").forEach(label => {
        label.htmlFor = label.htmlFor.replace(/_\d+$/, `_${index}`)
      })
    })
  }
}
